module.exports = __webpack_public_path__ + "img/calendar.96119e50.svg";